// extracted by mini-css-extract-plugin
export var dark = "spinner-module--dark--rs2Xy";
export var ldsDualRing = "spinner-module--lds-dual-ring--eQ5fy";
export var small = "spinner-module--small--+4Gwk";